
import { useLocale } from "@/contexts/localeContext";
import { ExpiryReason } from "@/models/ExpiryReason";
import { Form, Formik } from "formik";
import { FC, ReactElement, useState } from "react";
import Modal from 'react-modal';
import WizardSideBarStep from "@/models/WizardSideBarStep";
import { TranslationKeys } from "@/contexts/TranslationKeys";
import WizardTwo from "../wizard/wizardTwo";
import SummaryStep from "./SummaryStep";
import DetailStep from "./DetailStep";

interface ExpiryReasonModalProps {
    isOpen: boolean;
    onClose: () => void;
    currentItem: ExpiryReason;
    saveItem: (values: ExpiryReason) => void;
}

const ExpiryReasonModal: FC<ExpiryReasonModalProps> = ({ isOpen, onClose, currentItem, saveItem }) => {
    const { translate } = useLocale();
    const [currentStep, setCurrentStep] = useState(0)
    const title = translate.byKey(TranslationKeys.operationalCompliance)
    const [stepDescriptions, setStepDescriptions] = useState<{ [key: string]: string }>({
        step1: '',
        step2: '',
    });

    const steps: WizardSideBarStep[] = [
        {
            title: translate.byKey(TranslationKeys.details),
            description: stepDescriptions.step1,
            substeps: []
        },
        {
            title: translate.byKey(TranslationKeys.summary),
            description: '',
            substeps: []
        }
    ];

    const onLocalNext = (event: any) => {
        setCurrentStep(prev => prev + 1);
    }

    const onLocalBack = (event: any) => {
        setCurrentStep(prev => prev - 1);
    }

    const stepContent: ReactElement[] = [
        <DetailStep key={`1`} onNext={onLocalNext} setStepDescriptions={setStepDescriptions} />,
        <SummaryStep key={`2`} onBack={onLocalBack} />
    ]

    const handleClose = () => {
        setCurrentStep(0);
        setStepDescriptions({
            step1: '',
            step2: '',
        });
        onClose();
    }

    return <Modal
        isOpen={isOpen}
        ariaHideApp={false}
        overlayClassName="flex w-screen position-float-modal fixed top-0 left-0 h-screen bg-opacity-75 bg-white"
        className="bg-white border-none m-auto shadow select-none outline-none w-content">
        <Formik
            enableReinitialize={true}
            initialValues={currentItem}
            onSubmit={saveItem}>
            <Form>
                <WizardTwo
                    name={title}
                    step={currentStep}
                    onClose={handleClose}
                    sidebarSteps={steps}
                    stepContent={stepContent} />
            </Form>
        </Formik>
    </Modal>
}

export default ExpiryReasonModal;